import { createSelector } from 'reselect';
import _ from 'lodash';
import { createObserver as createRecomputeObserver } from '@jvitela/recompute';

var getKey = function getKey(state) {
  return state.app.key;
};

var getCompleteConfiguration = function getCompleteConfiguration(state) {
  return state.app.configuration;
};

var getCompleteLocalConfiguration = function getCompleteLocalConfiguration(state) {
  var _state$app;

  return (_state$app = state.app) === null || _state$app === void 0 ? void 0 : _state$app.localConfiguration;
};

var getCompleteLocalConfigurationObserver = createRecomputeObserver(getCompleteLocalConfiguration);
var getConfiguration = createSelector([getCompleteConfiguration, function (state, path) {
  return path;
}], function (configuration, path) {
  return _.get(configuration, path, null);
});
var getLocalConfiguration = createSelector([getCompleteLocalConfiguration, function (state, path) {
  return path;
}], function (localConfiguration, path) {
  return _.get(localConfiguration, path, null);
});
export default {
  getKey: getKey,
  getConfiguration: getConfiguration,
  getCompleteConfiguration: getCompleteConfiguration,
  getLocalConfiguration: getLocalConfiguration,
  getCompleteLocalConfiguration: getCompleteLocalConfiguration,
  getCompleteLocalConfigurationObserver: getCompleteLocalConfigurationObserver
};